/**
 * SiteLoading — what a site shows while it loads, which is usually nothing at all.
 *
 * A site is the space's own brand, so it never shows the Arcos hub's splash. A fast load paints
 * straight from blank to the page. Only a slow one — past DELAY_MS — shows a thin line along the
 * top, in the site's own colour when this browser has seen the site before (remembered by SiteApp),
 * and a neutral grey otherwise. No logo, no name, no Arcos.
 *
 * Inline styles only: this renders from the router's own bundle before SiteApp's code and CSS have
 * arrived.
 */
import { useEffect, useState } from 'react';
import { siteColorKey, dismissHubSplash } from './siteFetch.js';

const DELAY_MS = 450;

export default function SiteLoading({ slug }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    dismissHubSplash();
    const t = setTimeout(() => setShow(true), DELAY_MS);
    return () => clearTimeout(t);
  }, []);
  let color = '#9ca3af';
  try { color = localStorage.getItem(siteColorKey(slug)) || color; } catch { /* storage may be blocked */ }
  return (
    <div aria-busy="true" style={{ minHeight: '100vh' }}>
      {show && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 3, overflow: 'hidden', zIndex: 100 }}>
          <div style={{ width: '40%', height: '100%', background: color, animation: 'site-loading-slide 1.1s ease-in-out infinite' }} />
          <style>{'@keyframes site-loading-slide { from { transform: translateX(-100%); } to { transform: translateX(250%); } }'}</style>
        </div>
      )}
    </div>
  );
}
